export const SHIP_ROTATIONS = <const>['left', 'right', 'none'];
export type ShipRotation = typeof SHIP_ROTATIONS[number];

export const SHIP_ROTATION_MULTIPLIER: { [Key in ShipRotation]: number } = {
    left: -1,
    right: 1,
    none: 0
};